module.exports = __webpack_public_path__ + "static/media/student16.b572bf55.png";